



















































































































































































































































































































import Vue from 'vue'
export default Vue.extend({
  name: 'tutorial',

  data: () => ({
     model: 0,
    colors: [
      'primary',
      'secondary',
      'yellow darken-2',
      'red',
      'orange',
    ],
    tutorial:true,
  }),
  methods: {
      closeDialog(){
          this.$emit("selected",false)
          this.$data.tutorial=false;
      }
  },
  mounted: function () { 
  this.$root.$on('myEvent', (activated: boolean) => { // here you need to use the arrow function
      this.$data.tutorial=activated;
  })
  }
})
